// Card width, not viewport width: the grid drops from three to two to one column, and the
// columns are at their narrowest just before each of those switches. Measuring the card lets
// the header stack in every layout that gets too tight for the logo and title side by side.
export const STACKED_HEADER_BREAKPOINT = 360
